import { useFormik } from "formik";
import { useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { PatternFormat } from "react-number-format";
import {Person,LocalPhone,Email,Info,Visibility, VisibilityOff,CloudUpload, Search } from "@mui/icons-material";
import { Autocomplete, CircularProgress, InputLabel, Stack, TextField, Typography,Box } from "@mui/material";
import { Button, Grid } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { validationSchema } from "./validation";
import regulatoryIcon from "../../../../../../../assets/signup/regulatoryFirm.png";
import badge from "../../../../../../../assets/signup/badge.png";
import PasswordCritera from "./passwordCritera";
import useToggleState from "hooks/useTogglePassword";
import CustomizedDialogs from "../../../../../../../UI/footer-common-links/footerModal/footer-modal";
import ApiClient from "helpers/ApiClient";
import "./styles.scss";

const PersonalAccount = ({ setToggleSnackbar, setCognitoId, onSignupSuccess }: any) => {
  const { role }: any = useParams();
  const { state: navigationState }: any = useLocation();
  const [firm, setFirm] = useState("");
  const [signUpEmail, setSignUpEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState(0);
  const [state, toggleState]: any = useToggleState({
    password: false,
    confirmPassword: false,
    passCriteria: false,
  });

  const regulatoryFirms = [
    "Solicitor Regulation Authority",
    "Bar Standards Boards",
    "Intellectual Property Regulation Board.",
    "CILEx Regulation",
    "Council for Licensed Conveyancers",
    "Cost Lawyer Standards Board",
    "Master of the Faculties",
    "Cost Lawyer Standards Boards",
  ];

  //Formik Intitial Values
  const initialValues = {
    firstName: "",
    lastName: "",
    regulatoryFirm: firm || "",
    regulatoryNumber: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    file: "",
  };

  const handleOpenModal = (modalId: number) => {
    setId(modalId);
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);
  const hidePasswordCriteria = () => {
    toggleState("hideCriteria");
  };

  const signUpUser = (values: any) => {
    setIsLoading(true);
    const { email, password, firstName, lastName, phoneNumber } = values;
    const { regulatoryNumber, regulatoryFirm, file } = values;

    let SignUpFormData = new FormData();
    SignUpFormData.append("email", email);
    SignUpFormData.append("password", password);
    SignUpFormData.append("regulatoryFirm", regulatoryFirm);
    SignUpFormData.append("registrationNo", regulatoryNumber);
    SignUpFormData.append("roles", role);
    SignUpFormData.append("phoneNumber", phoneNumber);
    SignUpFormData.append("firstName", firstName.trim());
    SignUpFormData.append("lastName", lastName.trim());
    SignUpFormData.append("file", file);

    ApiClient.post("users/lawyer-signup", SignUpFormData)
      .then((res) => {
        setIsLoading(false);
        setCognitoId?.(res.data.user.cognitoId);
        setSignUpEmail(email);
        toggleState("hideCriteria");
        setToggleSnackbar({
          message: "Check your email for verification",
          isToggle: true,
          mode: "success",
          top: "110px",
        });
        onSignupSuccess?.(email);
      })
      .catch((error: any) => {
        const err = error.response.data.message;
        setIsLoading(false);
        const defaultError = err.slice(32, 45);
        if (defaultError === "already exist") {
          setToggleSnackbar({
            message: "Email or Phone number is already registered.",
            isToggle: true,
            mode: "error",
            top: "110px",
          });
        } else {
          setToggleSnackbar({ message: err, isToggle: true, mode: "error", top: "110px" });
        }
      });
  };

  const { values, errors, touched, setFieldValue, handleChange, handleSubmit, handleBlur } = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: () => {
      signUpUser(values);
    },
  });

  return (
    <Box className="personal-account">
      {state.passCriteria && <PasswordCritera value={values.password} />}
      
        <form onSubmit={handleSubmit}>
          <Typography variant="h5" sx={{ mb: "15px", color: "#434242", fontWeight: "500" }}>
            Account Details
          </Typography>

          <Grid container spacing={2} rowSpacing={3}>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="firstName"
                className={errors.firstName && touched.firstName ? "label-err" : "label"}
              >
                First Name <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                name="firstName"
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                error={!!(errors.firstName && touched.firstName)}
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={hidePasswordCriteria}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {errors.firstName && touched.firstName ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <Person fontSize="medium" />}
                    </InputAdornment>
                  ),
                }}
              />

              {errors.firstName && touched.firstName && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.firstName}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="lastName"
                className={errors.lastName && touched.lastName ? "label-err" : "label"}
              >
                Last Name <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                name="lastName"
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                error={!!(errors.lastName && touched.lastName)}
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={hidePasswordCriteria}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{errors.lastName && touched.lastName ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <Person fontSize="medium" />}</InputAdornment>
                  ),
                }}
              />

              {errors.lastName && touched.lastName && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.lastName}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="regulatoryFirm"
                className={errors.regulatoryFirm && touched.regulatoryFirm ? "label-err" : "label"}
              >
                Regulatory Firm <span style={{color:'red'}}>*</span>
              </InputLabel>

              <Autocomplete
                id="regulatoryFirm"
                freeSolo
                options={regulatoryFirms?.map((firm: string) => firm)}
                onInputChange={(event, value) => {
                  setFirm(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="company"
                    sx={{ background: "#fff" }}
                    fullWidth
                    type="text"
                    size="small"
                    variant="outlined"
                    error={!!(errors.regulatoryFirm && touched.regulatoryFirm)}
                    value={values.regulatoryFirm}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                          <InputAdornment position="end" sx={{ paddingRight: "12px" }}>
                            {errors.regulatoryFirm && touched.regulatoryFirm ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <img src={regulatoryIcon} alt="icon" />}
                          </InputAdornment>

                      ),
                      startAdornment:(
                        <InputAdornment position="start" sx={{ paddingLeft: "8px" }}>
                           <Search sx={{paddingLeft:'8px'}}/>
                          </InputAdornment>
                      )
                    }}
                  />
                )}
              />
              {errors.regulatoryFirm && touched.regulatoryFirm && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.regulatoryFirm}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="regulatoryNumber"
                className={
                  errors.regulatoryNumber && touched.regulatoryNumber ? "label-err" : "label"
                }
              >
                Regulatory Registration Number <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                name="regulatoryNumber"
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                error={!!(errors.regulatoryNumber && touched.regulatoryNumber)}
                value={values.regulatoryNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={hidePasswordCriteria}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {errors.regulatoryNumber && touched.regulatoryNumber ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <img src={badge} alt="badge" />}
                    </InputAdornment>
                  ),
                }}
              />
              {errors.regulatoryNumber && touched.regulatoryNumber && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.regulatoryNumber}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="phoneNumber"
                className={errors.phoneNumber && touched.phoneNumber ? "label-err" : "label"}
              >
                Phone Number <span style={{color:'red'}}>*</span>
              </InputLabel>
              <PatternFormat
                displayType="input"
                format="+## ###### ####"
                customInput={TextField}
                name="phoneNumber"
                type="text"
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                placeholder="+44 000000 0000"
                error={!!(errors.phoneNumber && touched.phoneNumber)}
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={hidePasswordCriteria}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {errors.phoneNumber && touched.phoneNumber ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <LocalPhone fontSize="medium" />}
                    </InputAdornment>
                  ),
                }}
              />

              {errors.phoneNumber && touched.phoneNumber && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.phoneNumber}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="email"
                className={errors.email && touched.email ? "label-err" : "label"}
              >
                Email <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                name="email"
                type="email"
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                error={!!(errors.email && touched.email)}
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={hidePasswordCriteria}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">{errors.email && touched.email ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <Email fontSize="medium" />}</InputAdornment>
                  ),
                }}
              />

              {errors.email && touched.email && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.email}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="password"
                className={errors.password && touched.password ? "label-err" : "label"}
              >
                Password <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                name="password"
                type={state.password ? "text" : "password"}
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                error={!!(errors.password && touched.password)}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={() => toggleState("showCriteria")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {state.password ? (
                        <Visibility sx={{ cursor: "pointer" }} fontSize="medium" onClick={() => toggleState("Password")} />
                      ) : (
                        <VisibilityOff sx={{ cursor: "pointer" }} fontSize="medium" onClick={() => toggleState("Password")} />
                      )}
                      {errors.password && touched.password && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}
                    </InputAdornment>
                  ),
                }}
              />
              {errors.password && touched.password && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.password === "Required" && "Required Field"}
                </Typography>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <InputLabel
                htmlFor="confirmPassword"
                className={
                  errors.confirmPassword && touched.confirmPassword ? "label-err" : "label"
                }
              >
                Confirm Password <span style={{color:'red'}}>*</span>
              </InputLabel>
              <TextField
                name="confirmPassword"
                type={state.confirmPassword ? "text" : "password"}
                sx={{ background: "#fff" }}
                fullWidth
                size="small"
                variant="outlined"
                error={!!(errors.confirmPassword && touched.confirmPassword)}
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={hidePasswordCriteria}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {state.confirmPassword ? (
                        <Visibility sx={{ cursor: "pointer" }} fontSize="medium" onClick={() => toggleState("confirmPassword")} />
                      ) : (
                        <VisibilityOff sx={{ cursor: "pointer" }} fontSize="medium" onClick={() => toggleState("confirmPassword")} />
                      )}
                      {errors.password && touched.password && <Info sx={{ color: "#DC3545" }} fontSize="medium" />}
                    </InputAdornment>
                  ),
                }}
              />
              {errors.confirmPassword && touched.confirmPassword && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.confirmPassword}
                </Typography>
              )}
            </Grid>
            <Grid item md={12} sm={12} sx={{ width: "100%" }}>
              <InputLabel
                htmlFor="file"
                className={errors.file && touched.file ? "label-err" : "label"}
              >
                License <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                sx={{ background: "#fff" }}
                fullWidth
                onChange={(e: any) => setFieldValue("file", e.target.files[0])}
                error={!!(errors.file && touched.file)}
                type="file"
                size="small"
                variant="outlined"
                InputProps={{
                  endAdornment: <InputAdornment position="end">{errors.file && touched.file ? <Info sx={{ color: "#DC3545" }} fontSize="medium" /> : <CloudUpload />}</InputAdornment>,
                }}
              />

              {errors.file && touched.file && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.file}
                </Typography>
              )}
            </Grid>
          </Grid>
              <Typography variant="body1" sx={{py:2.5}}>
                By signing up, you agree to{" "}
                <span className="secondary-color cursor-pointer" onClick={() => handleOpenModal(3)}>
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span className="secondary-color cursor-pointer" onClick={() => handleOpenModal(2)}>
                  Privacy Policy
                </span>
              </Typography>
          <Stack spacing={3} sx={{ textAlign: "center" }}>
            <Button className="btn-primary" sx={{ width: { xs: "100%", md: "auto", py: "10px !important" } }} type="submit" disableRipple variant="contained">
              {isLoading ? (
                <>
                  <CircularProgress size={20} sx={{ color: "#FFFFFF", mr: 1 }} />
                  <span> Loading...</span>
                </>
              ) : (
                <span>SAVE AND CONtINUE</span>
              )}
            </Button>
            <Typography variant="body1">
              Already have an account? {""}
              <Link to="/authentication/signin" className="link">
                Sign In
              </Link>
            </Typography>
          </Stack>
        </form>
      
      <CustomizedDialogs close={handleCloseModal} open={openModal} id={id} />
    </Box>
  );
};
export default PersonalAccount;
